var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as R from 'ramda';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SimpleChip from '../chips/SimpleChip/SimpleChip';
import VPopper from '../Popper/Popper';
import Spinner from '../Progress/Spinner/Spinner.vue';
import WithRender from './MultiSelect.html';
// TODO: Harshal Patil: Pending items
// 1. Fixing drop-down arrow direction
let MultiSelect = class MultiSelect extends Vue {
    // TODO: Harshal Patil: Pending items
    // 1. Fixing drop-down arrow direction
    constructor() {
        super(...arguments);
        this.focus = false;
        this.textInput = '';
        // @Watch('$refs.popper.isVisible')
        // public onPoperClose(value) {
        // }
    }
    get optionsEmpty() {
        // When to show no data found
        return this.options.length === 0 && !this.loading && !this.disabled;
    }
    get popperContentClass() {
        return {
            'multiselect--active': this.focus,
            'multiselect--disabled': this.disabled,
            'multiselect--error': this.error,
            'popper--no-content': (!this.textInput || this.textInput.length === 0)
                && this.options.length === 0,
        };
    }
    onAnchorClick() {
        this.$refs.input.focus();
    }
    onInputFocus() {
        this.focus = true;
        this.showPopper();
        this.$emit('focus');
    }
    onBlur() {
        this.focus = false;
        this.$emit('blur');
    }
    showPopper() {
        this.$refs.popper.show();
    }
    onKeyTab() {
        this.$nextTick()
            .then(() => this.$refs.popper.hide());
    }
    onKeyDown(event) {
        this.$nextTick().then(() => {
            if (this.options.length > 0) {
                const option = this.$refs.optionLabel[0];
                option.focus();
            }
        });
    }
    onInput() {
        this.$emit('search', this.textInput);
    }
    onKeyDelete() {
        if (this.textInput.length === 0) {
            const newValues = R.init(this.value);
            this.$emit('input', newValues);
        }
    }
    onOptionSelect(option) {
        if (!this.duplicate && this.value.indexOf(option) > -1) {
            return;
        }
        this.$emit('input', this.value.concat(option));
        // TODO: What to do with search text on selection
        this.textInput = '';
    }
    onChipRemove(v) {
        const selectedValues = this.value
            .filter((x) => x !== v);
        this.$emit('input', selectedValues);
    }
    onOptionsKeyDown(event, option) {
        const keycode = event.keyCode || event.which;
        event.preventDefault();
        this.$nextTick().then(() => {
            if (keycode === 40 /* DOWN */ && event.target.nextElementSibling) {
                event.target.nextElementSibling.focus();
            }
            if (keycode === 38 /* UP */ && event.target.previousElementSibling) {
                event.target.previousElementSibling.focus();
            }
            if (keycode === 13 /* ENTER */) {
                this.onOptionSelect(option);
                this.$refs.popper.hide();
                this.onAnchorClick();
            }
            if (keycode === 9 /* TAB */) {
                this.$refs.popper.hide();
            }
            return false;
        });
    }
};
__decorate([
    Prop({ default: 'Search' }),
    __metadata("design:type", String)
], MultiSelect.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], MultiSelect.prototype, "value", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], MultiSelect.prototype, "options", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], MultiSelect.prototype, "duplicate", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], MultiSelect.prototype, "loading", void 0);
__decorate([
    Prop({ default: () => (val) => val.label }),
    __metadata("design:type", Function)
], MultiSelect.prototype, "toText", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], MultiSelect.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], MultiSelect.prototype, "error", void 0);
MultiSelect = __decorate([
    WithRender,
    Component({
        components: {
            'popper': VPopper,
            'simple-chip': SimpleChip,
            'spinner': Spinner
        }
    })
], MultiSelect);
export { MultiSelect };
//# sourceMappingURL=MultiSelect.js.map